import React from 'react';
import {MenuItem} from '../../@types/menu';
import MenuItemComponent from './MenuItemComponent';
import './index.scss';

interface Props {
  model: MenuItem[]
}

export default function Menu({model}: Props) {
  return (
    <>
      <div className="app-menu">
        {
          model.map(f => f.separator
            ? <div key={f.id} className="app-menu-separator" role="separator"/>
            : <MenuItemComponent key={f.id} item={f}/>)
        }
      </div>
    </>
  );
}
